import React, { useEffect } from 'react';
import { makeStyles } from 'tss-react/mui';
import { Grid } from '@mui/material';
import userService from '../../user.service';
import styles from '../../Main/main.styles';
import NewUserInfo from '../../Main/NewUserInfo';
import { useState } from 'react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import CanCareDashboard from '../Dashboard/CanCareDashboard.jsx';
import { useLocation, useNavigate } from 'react-router-dom';
import { isEmpty } from 'lodash';
import axios from 'axios';
import CompanionScreen from '../../Main/CompanionScreen';
import { Dialog } from '@mui/material';
import Onboarding from '../../Main/Onboarding';
import { logout, refresh } from '../../utils/index';
import EmergencyButton from '../Components/EmergencyButton';
import useStore from '../../Store/Store';
import SideBar from '../../components/SideBar.jsx';

const useStyles = makeStyles()(styles);

const USER_TYPE = {
  device_user: 'DEVICE_USER',
  companion_user: 'COMPANION_USER',
  care_user: 'CARE_USER',
};

const careUserType = {
  careRecipient: 'CARE_RECIPIENT',
  cargiver: 'CAREGIVER',
};

function Main(props) {
  const { classes } = useStyles();
  const history = useNavigate();
  const location = useLocation();
  const [userPortalSettings, setUserPortalSettings] = useState(null);
  const width = useStore((state) => state.screenWidth);

  const user = useStore((state) => state.user);

  const [state, setState] = useState({
    stateUpdates: 0,
    showOnboarding: !localStorage['notFirstVisit'],
  });
  const [medications, setMedication] = useState(false);
  const [addCaregiver, setAddCaregiver] = useState(false);
  const [addCane, setAddCane] = useState(false);
  const [activeUserId, setActiveUserId] = useState('1');

  React.useEffect(() => {
    const fromLogin = sessionStorage.getItem('fromLogin');
    if (fromLogin === 'true') {
      sessionStorage.removeItem('fromLogin');
      window.location.reload();
    }
  }, []);

  const closeMedications = () => {
    setMedication(false);
  };
  const closeAddCaregiver = () => {
    localStorage.setItem('showAddCaregiver', 0);
    setAddCaregiver(false);
  };

  React.useEffect(() => {
    if (user) {
      const showAddCaregiver = localStorage['showAddCaregiver'] || 1;
      if (
        isEmpty(user?.canCareCaregivers) &&
        user?.careUserType === careUserType.careRecipient &&
        parseInt(showAddCaregiver) === 1
      ) {
        setAddCaregiver(true);
      }
    }
  }, [user]);

  const getPortalSettings = async () => {
    try {
      const result = await axios.get(process.env.REACT_APP_EXPRESS_URL + '/api/users/getUserPortalSettings', {
        headers: {
          'Content-Type': 'application/json',
          authorization: localStorage.getItem('auth'),
        },
      });
      setUserPortalSettings(result?.data?.results || null);
    } catch (exception) {
      console.log('Exception', exception);
    }
  };

  React.useEffect(() => {
    getPortalSettings();
  }, []);

  function closeOnboarding() {
    setState((prevState) => {
      return { ...prevState, showOnboarding: false };
    });
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'row' }}>
      {user?.userType === USER_TYPE.companion_user ? (
        <Grid container>
          <NewUserInfo
            user={user}
            logout={() => logout(user, history)}
            refresh={() => refresh(user)}
            setAddCane={() => setAddCane(true)}
          />

          <CompanionScreen user={user} addCane={addCane} closeAddCane={() => setAddCane(false)} />

          <Dialog className={classes.modal} open={state.showOnboarding} maxWidth={false}>
            <Onboarding closeModal={closeOnboarding}></Onboarding>
          </Dialog>
        </Grid>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'row', width: '100%' }}>
          <div style={{ width: width > 850 ? '240px' : '0px', flexShrink: 0 }}>
            <SideBar />
          </div>

          <div style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
            <NewUserInfo
              user={user}
              isSideBar={false}
              logout={() => logout(user, history)}
              refresh={() => refresh(user)}
              setMedication={() => {
                history('/main');
                setMedication(true);
              }}
              setAddCaregiver={() => {
                history('/main');
                setAddCaregiver(true);
              }}
              setAddCane={() => setAddCane(true)}
              activeUserId={activeUserId || ''}
            />
            <div>
              <CanCareDashboard
                user={user}
                refresh={refresh}
                medications={medications}
                addCaregiver={addCaregiver}
                closeMedications={closeMedications}
                closeAddCaregiver={closeAddCaregiver}
                addCane={addCane}
                closeAddCane={() => setAddCane(false)}
                userPortalSettings={userPortalSettings}
                getTab={(val) => setActiveUserId(val)}
              />
              <EmergencyButton />
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Main;
